/**
 * @name Courtesies.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\Invoice.js
 */

//import { apiCall, getBaseDir } from './utils.js';

import TableBuilder from '../../table_builder.js';
import moment from 'moment-timezone';
import Swal from 'sweetalert2';
var getBaseDir = null, apiCall = null, getBranchNameFromId = null, getSecUsers = null, float2moeda = null;

$(function()
{
    import('../../utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        getBranchNameFromId = utils.getBranchNameFromId;
        getSecUsers = utils.getSecUsers;
        float2moeda = utils.float2moeda;


        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname !== utils.getBaseDir() + 'financeiro/notas-fiscais')
            return;

        new FinancialInvoices(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
        });
    });
});

class FinancialInvoices
{
    constructor(onloadList=false, deps = {})
    {
        this.deps = deps;
        let self = this;
        this.tableHandler = new TableBuilder({
            table: '#table-financial-invoice-list',
            tableBody: '.js-financial-invoice-registrations-table',
            data: [],
            rowsPerPage: $('.js-invoice-per-page option:selected').val(),
            filter: false,
            maxPages: 0,
            customId: "CrudInvoicesHandler",
            tableRowRenderer: function(rowData) {
                return self.mountTableRow(rowData);
            },
            OnClickFirstPage: function() {
                self.fetchInvoicesList();
            },
            OnClickLastPage: function() {
                self.fetchInvoicesList();
            },
        });

        this.queryStartDate = moment().startOf('month').format('YYYY-MM-DD');
        this.queryEndDate = moment().endOf('month').format('YYYY-MM-DD');

        $('.js-invoice-start-date').val(this.queryStartDate)
        $('.js-invoice-end-date').val(this.queryEndDate)

        this.checkDateRange();
        this.fetchInvoicesList();
        this.bindDomEvents();
    }

    fetchInvoicesList() {
        let self = this;
        $(".js-financial-invoice-registrations-table").block(window._loader.loading);
        if (this.fetchRequest) {
            if (typeof this.fetchRequest.abort === 'function')
                this.fetchRequest.abort();
            this.fetchRequest = null;
        }
        $('.js-invoices-total-value').html('0,00');
        this.fetchRequest =apiCall({
            method: 'GET',
            endpoint: 'api/v1/sale/invoices',
            data: {
                startDate: self.queryStartDate,
                endDate: self.queryEndDate,
                page: self.tableHandler.getCurrentPage(),
                rowsPerPage: parseInt($('.js-invoice-per-page option:selected').val()),
                ...(self.branchId !== null && self.branchId !== '' ? {branchId: self.branchId} : {}),
                ...(self.searchQuery !== null && self.searchQuery !== '' ? {searchQuery: self.searchQuery} : {}),
                ...(self.searchInvoiceEmissionType !== null && self.searchInvoiceEmissionType !== '' ? {findSaleWithInvoiceEmission: self.searchInvoiceEmissionType} : {}),
            },
            successCallback: function(res) {
                $(".js-financial-invoice-registrations-table").unblock();
                if (!res.error) {
                    self.invoicesList = res.data;
                    self.invoicesTotal = res.total;
                    $('.js-invoices-total-value').html(float2moeda(res.valorTotal));
                    self.tableHandler.renderPage(self.tableHandler.getCurrentPage(), false, self.invoicesList, false, self.invoicesTotal);
                } else {
                    window.toast({
                        error: res.error,
                        text: res.message
                    })
                }
            },
            errorCallback: function(err) {
                $(".modal-edit-patient-dialog").unblock();
            }
        });
    }

    mountTableRow = (data) => {
        let row = `<tr>
            <td>${data.NOTA_FISCAL_ID == null ? 'Sem nota fiscal' : data.NOTA_FISCAL_ID}</td>
            <td>${data.ID}</td>
            <td>${data.FILIAL}</td>
            <td>${data.NOTA_FISCAL_CHAVE == null ? 'Sem nota fiscal' : data.NOTA_FISCAL_CHAVE}</td>
            <td>${this.mountInvoiceStatusBadge(data.NOTA_FISCAL_STATUS)}</td>
            <td>
                ${data.NOTA_FISCAL_CHAVE !== null ? `
                    <a href="https://thequiro.clinicasajustar.com.br/view-sale-invoice-xml.php?invoice_id=${data.NOTA_FISCAL_ID}" target="new" class="btn btn-sm btn-primary"><i class="fas fa-eye"></i> Ver XML</a>
                    <a href="https://thequiro.clinicasajustar.com.br/view-sale-invoice-pdf.php?invoice_id=${data.NOTA_FISCAL_ID}" target="new" class="btn btn-sm btn-primary"><i class="fas fa-eye"></i> Ver PDF</a>
                `: ''}
            </td>
        </tr>`;

        return row;
    }

    mountInvoiceStatusBadge = (status) => {
        switch(status) {
            case 'PENDENTE': {
                return `<span class="badge bg-warning">Pendente, aguardando emisão</span>`;
            }
            case 'AUTORIZADA': {
                return `<span class="badge bg-success">Autorizada</span>`;
            }
            case 'ERRO': {
                return `<span class="badge bg-success">Ocorreu um erro ao emitir</span>`;
            }
            default: {
                return `<span class="badge bg-warning">Não possui nota gerada</span>`;
            }
        }
    }

    checkDateRange = () => {
        const startDate = moment(this.queryStartDate);
        const endDate = moment(this.queryEndDate);
        const daysDiff = endDate.diff(startDate, 'days');

        if (daysDiff >= 28 && daysDiff <= 31 && this.branchId != null && this.branchId != '') {
            $('.js-invoices-filtered-action').removeClass('d-none');
        } else {
            $('.js-invoices-filtered-action').addClass('d-none');
        }
    }

    bindDomEvents = () => {
        let self = this;

        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-page-${self.tableHandler.getTableId()}`, function(e) {
            e.preventDefault();
            let pageId = $(this).text();
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchInvoicesList();
        });
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-previous-page-${self.tableHandler.getTableId()}`, function(e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() - 1; //console.log('previous pageId', pageId);
            if (pageId <= 0)
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchInvoicesList();
        });
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-next-page-${self.tableHandler.getTableId()}`, function(e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() + 1; //console.log('next pageId', pageId);
            if (pageId > self.tableHandler.getMaxPages())
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchInvoicesList();
        }); 
        $('.js-invoices-branch-selector').on('change', function() {
            self.branchId = $('.js-invoices-branch-selector option:selected').val();
            self.checkDateRange();
            self.fetchInvoicesList();
        });
        // Detecta busca por fornecedor
        $('.js-invoice-name-filter').on('input', function() {
            // make a typing debounce
            clearTimeout(self.searchQueryTimeout);
            self.searchQueryTimeout = setTimeout(function() {
                self.searchQuery = $('.js-invoice-name-filter').val().trim();
                if (self.searchQuery.length > 2) {
                    self.fetchInvoicesList();
                } else if (self.searchQuery.length == 0) {
                    self.searchQuery = '';
                    self.fetchInvoicesList();
                }
            }, 500);
        });
        // detecta busca por tipo de nota fisca
        $('.js-invoice-emission-type').on('change', function() {
            self.searchInvoiceEmissionType = $(this).val();
            self.fetchInvoicesList();
        });
        $('.js-invoice-per-page').on('change', function() {
            self.tableHandler.setRowsPerPage(parseInt($(this).val()));
            self.tableHandler.setCurrentPage(1);
            self.fetchInvoicesList();
        });
        $('.js-invoice-start-date').on('change', function() {
            const newStartDate = $(this).val();
            /*if (moment(newStartDate).isAfter(moment(self.queryEndDate))) {
                window.toast({
                    error: true,
                    text: 'A data inicial não pode ser maior que a data final'
                });
                $(this).val(self.queryStartDate);
                return;
            }*/
            self.queryStartDate = newStartDate;
            self.checkDateRange();
            self.fetchInvoicesList();
        });
        $('.js-invoice-end-date').on('change', function() {
            const newEndDate = $(this).val();
            /*if (moment(newEndDate).isBefore(moment(self.queryStartDate))) {
                window.toast({
                    error: true,
                    text: 'A data final não pode ser menor que a data inicial'
                });
                $(this).val(self.queryEndDate);
                return;
            }*/
            self.queryEndDate = newEndDate;
            self.checkDateRange();
            self.fetchInvoicesList();
        });

        let downloadInvervalMessage = null;

        $(document).on('click', '.js-invoices-download-in-xml', function() {
            let selfBtn = $(this);
            selfBtn.prop('disabled', true);
            Swal.fire({
                title: 'Confirmação',
                text: `Deseja realmente baixar os extratos em XML no período ${self.queryStartDate}-${self.queryEndDate} da unidade ${$('.js-invoices-branch-selector option:selected').text()}?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
            }).then((result) => {
                if (result.isConfirmed) {
                    if (downloadInvervalMessage) {
                        clearInterval(downloadInvervalMessage);
                    }
                    downloadInvervalMessage = setInterval(() => {
                        window.toast({
                            error: false, text: "Por favor aguarde enquanto junto todos os arquivos..."
                        });
                    }, 1000);
                    
                    // Cria a URL com os parâmetros
                    const downloadUrl = window._baseDir + `api/v1/financial/invoice/download?format=xml&startDate=${self.queryStartDate}&endDate=${self.queryEndDate}&branchId=${self.branchId}`;
                    
                    // Abre uma janela temporária para o download
                    const downloadWindow = window.open(downloadUrl, '_blank');
                    
                    // Monitora a janela e limpa quando fechada
                    const checkWindow = setInterval(() => {
                        if (downloadWindow && downloadWindow.closed) {
                            clearInterval(checkWindow);
                            clearInterval(downloadInvervalMessage);
                            selfBtn.prop('disabled', false);
                        }
                    }, 1000);

                    // Garante que o botão seja habilitado após 2 segundos
                    setTimeout(() => {
                        selfBtn.prop('disabled', false);
                        clearInterval(downloadInvervalMessage);
                    }, 2000);
                } else {
                    selfBtn.prop('disabled', false);
                }
            });
        });
        $(document).on('click', '.js-invoices-download-in-pdf', function() {
            let selfBtn = $(this);
            selfBtn.prop('disabled', true);
            Swal.fire({
                title: 'Confirmação',
                text: `Deseja realmente baixar os extratos em PDF no período ${self.queryStartDate}-${self.queryEndDate} da unidade ${$('.js-invoices-branch-selector option:selected').text()}?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
            }).then((result) => {
                if (result.isConfirmed) {
                    window.toast({
                        error: false, text: "Por favor aguarde enquanto junto todos os arquivos..."
                    });
                    apiCall({
                        method: 'GET',
                        endpoint: 'api/v1/financial/invoice/download?format=pdf',
                        data: {
                            startDate: self.queryStartDate,
                            endDate: self.queryEndDate,
                            branchId: self.branchId
                        },
                        responseType: 'blob',
                        successCallback: function(res) {
                            const blob = new Blob([res], { type: 'application/pdf' });
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = url;
                            a.download = `notas-fiscais-${self.queryStartDate}-${self.queryEndDate}.pdf`;
                            document.body.appendChild(a);
                            a.click();
                            window.URL.revokeObjectURL(url);
                            document.body.removeChild(a);
                            selfBtn.prop('disabled', false);
                        },
                        errorCallback: function(err) {
                            window.toast({
                                error: true,
                                text: 'Erro ao baixar os arquivos PDF'
                            });
                            selfBtn.prop('disabled', false);
                        }
                    });
                } else {
                    selfBtn.prop('disabled', false);
                }
            });
        });
    }
}